<div class="pricing-models">
    <div class="container">
    <h3 class="pricing-models__title">Modelos de precios complementarios</h3>
    <div class="pricing-models__grid">
      <div class="pricing-model" *ngFor="let model of models">
        <div class="pricing-model__icon">
          <i [class]="model.icon"></i>
        </div>
        <h4 class="pricing-model__title">{{ model.title }}</h4>
        <p class="pricing-model__desc">{{ model.description }}</p>
        <ul class="pricing-model__features">
          <li class="pricing-model__feature" *ngFor="let feature of model.features">
            <i class="bi bi-check-circle-fill pricing-model__feature-icon"></i>
            <span>{{ feature }}</span>
          </li>
        </ul>
        <button class="pricing-model__cta" (click)="requestInfo(model.title)">{{ model.ctaText }}</button>
      </div>
    </div>
    </div>
  </div>